module.exports = __webpack_public_path__ + "img/dashboard.f11bb974.svg";